module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "color": "white",
      "text-align": "center"
    },
    attrs: {
      "id": "page-notfound"
    }
  }, [_c('h1', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("  :( ")]), _vm._v(" "), _c('bre'), _vm._v(" "), _c('h3', [_vm._v(" Oooops, sorry, seems like we brought you to the wrong place. ")]), _vm._v(" "), _c('h5', [_vm._v(" Our bad, probably gave you the wrong URL, click the title to go back to the adventure feed.")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-622543c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionNotFound.vue
// module id = 313
// module chunks = 0